import React from 'react';

import type { Avatar } from 'bundles/connect/types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

const AVATAR_PLACEHOLDER = '/images/broker_default_photos/photo-missing-original.png';

type AvatarsProps = {
  avatars: Avatar[];
}

export default function Avatars({ avatars }: AvatarsProps) {
  return (
    <div className="avatar-group">
      {avatars.slice(0, 4).map(avatar => (
        <OverlayTrigger
          key={avatar.tooltip}
          overlay={<Tooltip>{avatar.tooltip}</Tooltip>}
          placement="top"
        >
          {avatar.image !== AVATAR_PLACEHOLDER ?
            (
              <img
                alt={avatar.tooltip}
                className="avatar avatar-sm"
                src={avatar.image}
              />
            ) : (
              <span className="avatar avatar-sm avatar-fallback">{avatar.initials}</span>
            )}
        </OverlayTrigger>
      ))}
      {avatars.length > 4 && (
        <OverlayTrigger
          key="more-avatars"
          overlay={<Tooltip>+{avatars.length - 4} more</Tooltip>}
          placement="top"
        >
          <span className="avatar avatar-sm">+{avatars.length - 4}</span>
        </OverlayTrigger>
      )}
    </div>
  );
}
